import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import VideoShowcase from './components/VideoShowcase';
import Services from './components/Services';
import Products from './components/Products';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FeaturedVideo from './components/FeaturedVideo';
import BrandPage from './pages/BrandPage';
import ModelPage from './pages/ModelPage';
import './styles.css';

const audioSources = {
  ar: "/assets/audio/welcome-audio.wav",
  en: "/assets/audio/welcome-audio-en.wav"
};

function App() {
  const { i18n } = useTranslation();
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  useLayoutEffect(() => {
    document.body.className = '';
    document.body.classList.add(`${theme}-mode`);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    }
  }, [i18n.language]);

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) audioRef.current.pause();
    else audioRef.current.play().catch(err => console.log("Audio play failed:", err));
    setIsPlaying(!isPlaying);
  };

  return (
    <BrowserRouter>
      <div className="app-root" style={{ backgroundImage: `url(/assets/images/background.jpg)` }}>
        <audio
          ref={audioRef}
          src={audioSources[i18n.language]}
          key={i18n.language}
          onEnded={() => setIsPlaying(false)}
        />

        <Header theme={theme} toggleTheme={toggleTheme} />

        <Routes>
          <Route
            path="/"
            element={
              <main>
                <Hero onPlayAudio={togglePlay} isPlaying={isPlaying} />
                <WhyUs />
                <Services />
                <VideoShowcase />
                <Products />
                <FeaturedVideo />
                <Testimonials />
                <FAQ />
                <Blog />
                <Contact />
              </main>
            }
          />
          <Route path="/brand/:brandSlug" element={<BrandPage />} />
          <Route path="/brand/:brandSlug/model/:modelSlug" element={<ModelPage />} />
        </Routes>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
